import { createSelector } from "reselect";
import { AppState } from "../reducers";

export const settingsSelector = createSelector(
  ({ settings }: AppState) => settings,
  (settings) => settings
);